import {
  ref, reactive, watch, toRef,
} from '@vue/composition-api'
import axiosIns from '@/libs/axios'

export default function useGroups(ctx) {
  const tableColumns = [
    {
      key: 'name',
    },
    {
      key: 'description',
      formatter: (_, _1, item) => (item.description ? item.description : '_'),
      // tdClass: (_, _1, item) => (item.description ? 'groups__description' : ''),
    },
    {
      key: 'target',
    },
    'actions',
  ]
  const groups = ref([])
  const total = ref()
  const loadingGroups = ref(false)
  const queryParams = reactive({
    target: undefined,
    name: undefined,
    page: 1,
    perPage: 10,
  })
  const currTarget = ref('All')
  const targetOptions = [
    { label: 'All', key: 'All' },
    { label: 'Drivers', key: 'drivers' },
    { label: 'Riders', key: 'riders' },
  ]
  const textFormatter = text => {
    if (!text) return '_'
    const temp = `${text.slice(0, 20)}<br /> ${text.slice(21, 40)}`
    if (text.length > 40) return `${temp}...`
    return temp
  }
  const fetchGroups = async () => {
    loadingGroups.value = true
    try {
      const temp = { ...queryParams }
      if (currTarget.value === 'All') {
        temp.target = undefined
      } else {
        temp.target = currTarget.value
      }
      if (queryParams.name) {
        delete temp.page
        delete temp.perPage
      }
      const result = await axiosIns.get('/groups', {
        params: temp,
      })
      const { data, total: totalRecords } = result.data.data
      total.value = totalRecords
      groups.value = data
    } catch (error) {
      console.log(error)
    } finally {
      loadingGroups.value = false
    }
  }
  const search = () => {
    fetchGroups()
  }
  const currentGroup = ref()
  const openDeleteModal = data => {
    currentGroup.value = data
    ctx.root.$bvModal.show('delete-group')
  }
  fetchGroups()

  watch([toRef(queryParams, 'perPage'), toRef(queryParams, 'page')], () => {
    fetchGroups()
  })

  return {
    tableColumns,
    groups,
    total,
    loadingGroups,
    queryParams,
    targetOptions,
    search,
    currTarget,
    openDeleteModal,
    currentGroup,
    fetchGroups,
    textFormatter,
  }
}
